import {Part} from "../part";
import {PartMenuType} from "../../../visComponents/constants";
import BackgroundBG from "../subparts/backgrounds/BackgroundBG";

export default class Background extends Part {
  static id = 'Background';
  constructor() {
    super(true, false, PartMenuType.Complex);

    this.menuType = PartMenuType.Complex;
    this.partName = 'Background';
    this.categoryEnabled = false;
  }

  load(dbFeature) {
    let relatedItemName = "",
      RelatedItemClass = null;
    switch (dbFeature.groupName) {
      case "Background":
        switch (true) {
          case dbFeature.displayName.includes("BG "):
            relatedItemName = "backgroundBG";
            RelatedItemClass = BackgroundBG;
            break;
        }
        break;
      default:
        break;
    }
    if (relatedItemName) {
      if (!this[relatedItemName]) {
        this[relatedItemName] = new RelatedItemClass(true);
        this.relatedItems.push(this[relatedItemName]);
      }
      if (!this.categoryEnabled) {
        this.categoryEnabled = true
      }
      this[relatedItemName].getParent = () => this;
      this[relatedItemName].load(dbFeature);
      return true
    }
    return false
  }

  isSubTypeWithItems() {
    return false;
  }

  handleSubPartClick() {

  }

}
